import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const IndustryTapeSection = () => {
    // The list of travel industry segments provided
    const industryTags = [
        "Travel Brands", "Tourism Boards", "Hotels", "Resorts",
        "Unique Stays", "Theme Parks", "Attractions",
        "Adventure & Experience Providers", "Cruise",
        "Travel Gear & Luggage Brands", "Airlines",
        "Travel-Tech Brands", "Travel Ancillary Services"
    ];

    const handleWhatsAppClick = () => {
        window.open(
            'https://wa.me/918438506813?text=Hi%20Travel%20Rethink%20Ways%0A%0AI%27m%20interested%20in%20exploring%20partnership%20opportunities%20with%20your%20platform.',
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <section className="w-full bg-white pt-0 lg:pt-5 pb-0 overflow-hidden relative flex flex-col items-center">

            <style>{`
                @keyframes marquee-left {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                @keyframes marquee-right {
                    0% { transform: translateX(-50%); }
                    100% { transform: translateX(0); }
                }
                .animate-marquee-left {
                    display: flex;
                    width: max-content;
                    animation: marquee-left 90s linear infinite;
                }
                .animate-marquee-right {
                    display: flex;
                    width: max-content;
                    animation: marquee-right 90s linear infinite;
                }
                /* Optional pause on hover for readability */
                .animate-marquee-left:hover, .animate-marquee-right:hover {
                    animation-play-state: paused;
                }
            `}</style>

            {/* Overlapping Tape Container - TOP */}
            {/* Optimized container heights for mobile/tablet to prevent massive white gaps */}
            <div className="relative w-full h-[80px] sm:h-[180px] md:h-[240px] lg:h-[330px] flex items-center justify-center lg:mt-1 pb-0 sm:pb-[30px] lg:pb-[50px]">

                {/* --- TAPE 1: Background Strip (Angles Down, Moves Left) --- */}
                <div
                    className="absolute w-[200vw] left-[-50vw] lg:w-[150vw] lg:left-[-25vw] bg-[#D02525] z-10 transform rotate-[4deg] sm:rotate-[5deg] lg:rotate-[8deg]"
                >
                    <div className="animate-marquee-left py-0 sm:py-3 lg:py-4">
                        {/* Render twice for seamless infinite loop */}
                        {[...Array(2)].map((_, i) => (
                            <div key={`tape1-top-${i}`} className="flex items-center px-4">
                                {industryTags.map((tag, index) => (
                                    <React.Fragment key={index}>
                                        <span className="text-white font-sans font-bold text-[13px] sm:text-base md:text-xl lg:text-3xl uppercase tracking-wide whitespace-nowrap">
                                            {tag}
                                        </span>
                                        <span className="text-white font-sans font-bold text-base sm:text-lg md:text-xl lg:text-3xl mx-3 sm:mx-5 md:mx-6 lg:mx-8 opacity-100">
                                            •
                                        </span>
                                    </React.Fragment>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                {/* --- TAPE 2: Middle Strip (Angles Up, Moves Right) --- */}
                <div
                    className="absolute w-[200vw] left-[-50vw] lg:w-[150vw] lg:left-[-25vw] bg-[#D02525] z-20 transform -rotate-[4deg] sm:-rotate-[5deg] lg:-rotate-[8deg]"
                >
                    <div className="animate-marquee-right py-0 sm:py-3 lg:py-4">
                        {[...Array(2)].map((_, i) => (
                            <div key={`tape2-top-${i}`} className="flex items-center px-4">
                                {industryTags.map((tag, index) => (
                                    <React.Fragment key={index}>
                                        <span className="text-white font-sans font-bold text-[13px] sm:text-base md:text-xl lg:text-3xl uppercase tracking-wide whitespace-nowrap">
                                            {tag}
                                        </span>
                                        <span className="text-white font-sans font-bold text-base sm:text-lg md:text-xl lg:text-3xl mx-3 sm:mx-5 md:mx-6 lg:mx-8 opacity-100">
                                            •
                                        </span>
                                    </React.Fragment>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            {/* Section Headline */}
            <div className="text-center z-40 my-0 sm:my-8 md:mb-10 lg:mb-0 px-4 sm:px-8 relative">

                {/* Updated to a serif font to match your screenshot */}
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#d02525] border-gray-800 mb-4 sm:mb-6 shadow-sm mt-2 sm:mt-5">
                    <span className="text-white font-poppins text-[10px] sm:text-xs md:text-sm font-semibold tracking-widest uppercase">
                        WHO WE WORK WITH
                    </span>
                </div>

                {/* Smoothed Typography Scaling */}
                <h2 className="text-black font-medium text-[22px] sm:text-[34px] md:text-4xl lg:text-[54px] font-bold tracking-tight leading-tight mt-3 sm:mt-5">
                    Powering Growth for Travel Brands
                </h2>

                <p className="text-black font-poppins text-[18px] sm:text-base md:text-xl lg:text-3xl max-w-[95%] sm:max-w-4xl lg:max-w-6xl mx-auto mt-4 sm:mt-6 normal-case leading-[1.2] lg:leading-[54px] tracking-1">
                    From Tourism Boards, Hotels, Resorts, and Unique Stays to Airlines,
                    Cruise Journeys, Attractions, Adventure Experiences, Tour Operators,
                    Travel-Tech Platforms, Mobility Services, and travel-focused lifestyle brands
                    shaping how modern travelers discover the world
                </p>
                <button
                    type="button"
                    onClick={handleWhatsAppClick}
                    className="hidden lg:inline-flex items-center justify-center gap-2 sm:gap-2 w-auto 2xl:w-[175px] h-[44px] lg:h-[40px] xl:h-[44px] 2xl:h-[50px] mt-0 sm:mt-8 px-5 2xl:px-6 bg-[#15803d] hover:bg-[#15803d] transition-colors text-white text-[14px] font-poppins font-semibold rounded-[30px] whitespace-nowrap "
                >
                    <FontAwesomeIcon icon={faWhatsapp} className="text-white w-[24px] h-[24px] sm:w-[28px] sm:h-[28px] lg:w-[20px] lg:h-[20px] xl:w-[24px] xl:h-[24px] 2xl:w-[24px] 2xl:h-[24px]" aria-hidden="true" />
                    <span className="text-[18px] sm:text-[17px] lg:text-[15px] xl:text-[17px] 2xl:text-[18px] font-bold">Starts Here</span>
                </button>
            </div>

            {/* Overlapping Tape Container - BOTTOM */}
            <div className="relative w-full h-[70px] sm:h-[180px] md:h-[240px] lg:h-[330px] flex items-center justify-center mt-0 sm:mt-10 pb-[1px]">

                {/* --- TAPE 1: Background Strip (Angles Down, Moves Left) --- */}
                <div
                    className="absolute w-[200vw] left-[-50vw] lg:w-[150vw] lg:left-[-25vw] bg-[#D02525] z-10 transform rotate-[4deg] sm:rotate-[5deg] lg:rotate-[8deg]"
                >
                    <div className="animate-marquee-left py-0 sm:py-3 lg:py-4">
                        {/* Render twice for seamless infinite loop */}
                        {[...Array(2)].map((_, i) => (
                            <div key={`tape1-${i}`} className="flex items-center px-4">
                                {industryTags.map((tag, index) => (
                                    <React.Fragment key={index}>
                                        <span className="text-white font-sans font-bold text-[13px] sm:text-base md:text-xl lg:text-3xl uppercase tracking-wide whitespace-nowrap">
                                            {tag}
                                        </span>
                                        <span className="text-white font-sans font-bold text-base sm:text-lg md:text-xl lg:text-3xl mx-3 sm:mx-5 md:mx-6 lg:mx-8 opacity-100">
                                            •
                                        </span>
                                    </React.Fragment>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                {/* --- TAPE 2: Middle Strip (Angles Up, Moves Right) --- */}
                <div
                    className="absolute w-[200vw] left-[-50vw] lg:w-[150vw] lg:left-[-25vw] bg-[#D02525] z-20 transform -rotate-[4deg] sm:-rotate-[5deg] lg:-rotate-[8deg]"
                >
                    <div className="animate-marquee-right py-0 sm:py-3 lg:py-4">
                        {[...Array(2)].map((_, i) => (
                            <div key={`tape2-${i}`} className="flex items-center px-4">
                                {industryTags.map((tag, index) => (
                                    <React.Fragment key={index}>
                                        <span className="text-white font-sans font-bold text-[13px] sm:text-base md:text-xl lg:text-3xl uppercase tracking-wide whitespace-nowrap">
                                            {tag}
                                        </span>
                                        <span className="text-white font-sans font-bold text-base sm:text-lg md:text-xl lg:text-3xl mx-3 sm:mx-5 md:mx-6 lg:mx-8 opacity-100">
                                            •
                                        </span>
                                    </React.Fragment>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

            </div>

        </section>
    );
};

export default IndustryTapeSection;